import request from './request'

// 统一域名，所有页面图片拼接从这里导入
export const BASE_URL = 'https://cdn.goldwjk.cc'

// 登录
export const login = (data) => request.post('/index/api.login/login', data)

// 注册
export const reg = (data) => request.post('/index/api.login/reg', data)

// 获取轮播图
export const getBanner = () => request.get('/index/api.index/getBanner')

// 获取首页底部交易对
export const getProducts = () => request.get('/index/api.index/getProducts')

// 获取公告
export const getAnnouncement = () => request.get('/index/api.index/getAnnouncement')

// 更新首页产品波动
export const updateProducts = (data) => request.get('/index/api.index/ajaxdata', { params: data })

// 客服链接
export const getService = () => request.get('/index/api.index/service')

// 关于我们
export const aboutUs = (params) => request.get('/index/api.index/aboutUs', { params })

// 隐私政策
export const privacyPolicy = (params) => request.get('/index/api.index/privacyPolicy', { params })

// K线顶部波动信息
export const getprodata = (data) => request.get('/index/api.index/getprodata', { params: data })

// K线图数据
export const getkdata = (data) => request.get('/index/api.index/getkdata', { params: data })

// K线最新数据
export const getKupdate = (data) => request.get('/index/api.index/ajaxpro', { params: data })

// 委托页数据
export const getGoods = (data) => request.get('/index/api.index/goods', { params: data })

// 交易接口
export const addorder = (data) => request.post('/index/api.user/addorder', data)

// 账户页数据
export const account = (data) => request.post('/index/api.user/account', data)

// 交易记录
export const ajaxorderList = (data) => request.post('/index/api.user/ajaxorder_list', data)

// 充值记录
export const rechargeRecord = (data) => request.post('/index/api.user/recharge_record', data)

// 提现记录
export const cashRecord = (data) => request.post('/index/api.user/cash_record', data)

// 资金流水（账单）
export const fund = (data) => request.post('/index/api.user/fund', data)

// 充值信息查询
export const recharge = (data) => request.get('/index/api.user/recharge', { params: data })

// 充值申请
export const recharges = (data) => request.post('/index/api.user/recharge', data)

// 提现信息查询
export const cash = (data) => request.get('/index/api.user/cash', { params: data })

// 提现申请
export const cashs = (data) => request.post('/index/api.user/cash', data)

// 用户信息查询
export const index = (data) => request.post('/index/api.user/index', data)

// 实名信息查询
export const verified = (data) => request.get('/index/api.user/verified', { params: data })

// 实名认证
export const verifieds = (data) => request.post('/index/api.user/verified', data)

// 登录密码修改
export const pwdLogin = (data) => request.post('/index/api.user/pwd_login', data)

// 交易密码修改
export const pwdPay = (data) => request.post('/index/api.user/pwd_pay', data)

// 银行卡列表
export const bankCard = (data) => request.post('/index/api.user/bank_card', data)

// 添加银行卡
export const addCard = (data) => request.post('/index/api.user/add_card', data)

// 绑定支付宝
export const updateAlipay = (data) => request.post('/index/api.user/update_alipay', data)

// 上传图片
export const upload = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/index/plugs/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

